import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

import VuePageTitle from 'vue-page-title'

Vue.use(VuePageTitle, {
  // prefix: 'CompForge | ',
  suffix: ' | CompForge'
})

// import JsonCSV from 'vue-json-csv'
// Vue.component('downloadCsv', JsonCSV)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
